import { Injectable, Injector } from '@angular/core';
import { BaseResourceService } from 'eddydata-lib';
import { IndicadorAdicional } from 'projects/eddydata-lib/src/lib/entidade/planejamento/indicador-adicional.model';

@Injectable({
  providedIn: 'root'
})
export class IndicadorAdicionalService extends BaseResourceService<IndicadorAdicional> {

  constructor(
    protected injector: Injector
  ) {
    super(`indicadores-adicionais`, injector);
  }
}
